<template lang="pug">
md-input-container
  label(for='countries') Country
  md-select#countries(multiple, v-model='selectedCountries', @selected='onCountrySelected')
    md-option(v-for='country in countries', :value='country.code' :key="country.code") {{ country.name }}
</template>

<script>
  import countriesList from '../../assets/data/countries/index';

  export default {
    props: {
      value: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        selectedCountries: this.value,
        countries: countriesList
      };
    },
    methods: {
      onCountrySelected(countries) {
        this.$emit('input', countries);
      }
    }
  };
</script>

<style lang="scss" scoped>
  #countries {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/country/CountrySelector.vue